/**
 * Track Page Routing
 */

import { Route } from 'found';
import * as React from 'react';

import Heading from '../../components/atoms/text/Heading';
import TrackPage, { TrackPageProps } from '../../components/pages/Track';
import Page from '../../components/templates/Page';
import { TrackPageQuery } from '../../relay/track';
import {
  getLicenseParamsForRouteQuery,
  LoadingPage,
  PrepareVariablesFunction,
  RenderRouteFunction,
} from '../../utils/router';

interface IRouteParams {
  slug: string;
}

type IVariables = Required<Pick<GQL.ITrackOnQueryArguments,
  | 'license_params'
  | 'slug'>>;

const prepareVariables: PrepareVariablesFunction<IRouteParams, IVariables> =
  ({ slug }, match) => ({
    slug,
    license_params: getLicenseParamsForRouteQuery(match),
  });

const render: RenderRouteFunction<TrackPageProps> = ({ Component, props }) => {
  if (!Component || !props) {
    return <LoadingPage />;
  }

  return props.track ? <Component {...props} /> : (
    <Page id="track" className="not-found">
      <Heading is="h2">Track Not Found</Heading>
    </Page>
  );
};

export const TrackPageRoute = (
  <Route
    path="track/:slug"
    Component={TrackPage}
    query={TrackPageQuery}
    prepareVariables={prepareVariables}
    render={render}
  />
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/router/routes/TrackPage.tsx